const avatars = [
  {
    id: "superhero",
    label: "Superhero",
    svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="48" fill="#fff3e0"/>
      <!-- Cape -->
      <path d="M25,60 Q50,90 75,60 Q65,80 50,85 Q35,80 25,60Z" fill="#FF6A00"/>
      <!-- Body -->
      <rect x="35" y="55" width="30" height="25" rx="5" fill="#1a1a1a"/>
      <!-- S logo -->
      <text x="50" y="73" text-anchor="middle" fill="#FF6A00" font-size="12" font-weight="900" font-family="Arial">S</text>
      <!-- Head -->
      <circle cx="50" cy="38" r="18" fill="#FFCC80"/>
      <!-- Mask -->
      <path d="M32,36 Q40,30 50,33 Q60,30 68,36 Q68,41 50,41 Q32,41 32,36Z" fill="#FF6A00"/>
      <!-- Eyes -->
      <circle cx="42" cy="38" r="3" fill="white"/>
      <circle cx="58" cy="38" r="3" fill="white"/>
      <circle cx="43" cy="38" r="1.5" fill="#1a1a1a"/>
      <circle cx="59" cy="38" r="1.5" fill="#1a1a1a"/>
      <!-- Smile -->
      <path d="M43,46 Q50,52 57,46" stroke="#1a1a1a" stroke-width="2" fill="none" stroke-linecap="round"/>
      <!-- Hair -->
      <path d="M33,32 Q36,20 50,20 Q64,20 67,32 Q60,24 50,25 Q40,24 33,32Z" fill="#1a1a1a"/>
    </svg>`
  },
  {
    id: "footballer",
    label: "Footballer",
    svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="48" fill="#E8F5E9"/>
      <!-- Shirt -->
      <path d="M30,60 L35,55 L50,58 L65,55 L70,60 L70,82 L30,82Z" fill="#FF6A00"/>
      <!-- Shirt stripes -->
      <rect x="47" y="55" width="6" height="27" fill="white" opacity="0.3"/>
      <!-- Number -->
      <text x="50" y="75" text-anchor="middle" fill="white" font-size="11" font-weight="900" font-family="Arial">10</text>
      <!-- Head -->
      <circle cx="50" cy="38" r="18" fill="#FFCC80"/>
      <!-- Hair -->
      <path d="M33,30 Q36,18 50,18 Q64,18 67,30 Q62,22 50,23 Q38,22 33,30Z" fill="#8D6E63"/>
      <!-- Eyes -->
      <circle cx="43" cy="37" r="3" fill="white"/>
      <circle cx="57" cy="37" r="3" fill="white"/>
      <circle cx="44" cy="37" r="1.5" fill="#1a1a1a"/>
      <circle cx="58" cy="37" r="1.5" fill="#1a1a1a"/>
      <!-- Smile -->
      <path d="M43,46 Q50,52 57,46" stroke="#1a1a1a" stroke-width="2" fill="none" stroke-linecap="round"/>
      <!-- Ball -->
      <circle cx="72" cy="75" r="10" fill="white" stroke="#1a1a1a" stroke-width="1.5"/>
      <path d="M66,70 L72,65 L78,70 L76,77 L68,77Z" fill="#1a1a1a" opacity="0.3"/>
    </svg>`
  },
  {
    id: "astronaut",
    label: "Astronaut",
    svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="48" fill="#E3F2FD"/>
      <!-- Suit body -->
      <rect x="30" y="60" width="40" height="25" rx="10" fill="#e0e0e0"/>
      <!-- Suit details -->
      <rect x="42" y="65" width="16" height="10" rx="3" fill="#FF6A00"/>
      <!-- Helmet -->
      <circle cx="50" cy="40" r="22" fill="#e0e0e0"/>
      <!-- Visor -->
      <path d="M35,38 Q50,52 65,38 Q65,25 50,22 Q35,25 35,38Z" fill="#64B5F6" opacity="0.8"/>
      <!-- Visor shine -->
      <path d="M39,30 Q44,26 50,25" stroke="white" stroke-width="2.5" fill="none" stroke-linecap="round" opacity="0.7"/>
      <!-- Face inside visor -->
      <circle cx="44" cy="36" r="2.5" fill="white"/>
      <circle cx="56" cy="36" r="2.5" fill="white"/>
      <circle cx="45" cy="36" r="1.2" fill="#1a1a1a"/>
      <circle cx="57" cy="36" r="1.2" fill="#1a1a1a"/>
      <path d="M44,43 Q50,48 56,43" stroke="white" stroke-width="1.5" fill="none" stroke-linecap="round"/>
      <!-- Stars -->
      <text x="20" y="30" font-size="8">⭐</text>
      <text x="72" y="25" font-size="6">✨</text>
    </svg>`
  },
  {
    id: "rockstar",
    label: "Rockstar",
    svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="48" fill="#FCE4EC"/>
      <!-- Guitar -->
      <ellipse cx="72" cy="72" rx="10" ry="12" fill="#FF6A00"/>
      <rect x="70" y="55" width="4" height="20" fill="#8D6E63"/>
      <line x1="68" y1="60" x2="76" y2="60" stroke="#1a1a1a" stroke-width="1"/>
      <line x1="68" y1="63" x2="76" y2="63" stroke="#1a1a1a" stroke-width="1"/>
      <!-- Body/jacket -->
      <path d="M30,60 L35,54 L50,58 L65,54 L70,60 L68,82 L32,82Z" fill="#1a1a1a"/>
      <!-- Jacket lapels -->
      <path d="M35,54 L50,65 L50,82" fill="#FF6A00" opacity="0.8"/>
      <!-- Head -->
      <circle cx="50" cy="37" r="18" fill="#FFCC80"/>
      <!-- Wild hair -->
      <path d="M32,28 Q28,15 40,12 Q50,8 60,12 Q72,15 68,28 Q63,18 50,19 Q37,18 32,28Z" fill="#1a1a1a"/>
      <path d="M33,25 Q30,18 35,14" stroke="#1a1a1a" stroke-width="4" stroke-linecap="round" fill="none"/>
      <path d="M67,25 Q70,18 65,14" stroke="#1a1a1a" stroke-width="4" stroke-linecap="round" fill="none"/>
      <!-- Sunglasses -->
      <rect x="33" y="34" width="13" height="8" rx="3" fill="#1a1a1a"/>
      <rect x="54" y="34" width="13" height="8" rx="3" fill="#1a1a1a"/>
      <line x1="46" y1="38" x2="54" y2="38" stroke="#1a1a1a" stroke-width="2"/>
      <!-- Smirk -->
      <path d="M44,47 Q52,52 58,48" stroke="#1a1a1a" stroke-width="2" fill="none" stroke-linecap="round"/>
    </svg>`
  },
  {
    id: "princess",
    label: "Princess",
    svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="48" fill="#F3E5F5"/>
      <!-- Dress -->
      <path d="M28,58 Q50,65 72,58 Q78,82 50,85 Q22,82 28,58Z" fill="#FF6A00"/>
      <!-- Dress shimmer -->
      <path d="M38,60 Q50,67 62,60 Q66,75 50,78 Q34,75 38,60Z" fill="white" opacity="0.2"/>
      <!-- Bodice -->
      <rect x="36" y="54" width="28" height="12" rx="4" fill="#FF6A00"/>
      <!-- Stars on dress -->
      <text x="44" y="77" font-size="8" fill="white" opacity="0.7">✦</text>
      <text x="54" y="72" font-size="6" fill="white" opacity="0.7">✦</text>
      <!-- Head -->
      <circle cx="50" cy="37" r="18" fill="#FFCC80"/>
      <!-- Hair -->
      <path d="M33,32 Q32,18 50,16 Q68,18 67,32 Q62,22 50,23 Q38,22 33,32Z" fill="#FFB300"/>
      <!-- Side curls -->
      <path d="M32,35 Q28,42 32,48" stroke="#FFB300" stroke-width="5" fill="none" stroke-linecap="round"/>
      <path d="M68,35 Q72,42 68,48" stroke="#FFB300" stroke-width="5" fill="none" stroke-linecap="round"/>
      <!-- Crown -->
      <path d="M34,24 L38,14 L44,22 L50,12 L56,22 L62,14 L66,24Z" fill="#FFD700" stroke="#FF6A00" stroke-width="1.5"/>
      <!-- Crown gems -->
      <circle cx="50" cy="17" r="3" fill="#FF6A00"/>
      <circle cx="38" cy="20" r="2" fill="#E91E63"/>
      <circle cx="62" cy="20" r="2" fill="#9C27B0"/>
      <!-- Eyes -->
      <circle cx="43" cy="38" r="3" fill="white"/>
      <circle cx="57" cy="38" r="3" fill="white"/>
      <circle cx="44" cy="38" r="1.5" fill="#1a1a1a"/>
      <circle cx="58" cy="38" r="1.5" fill="#1a1a1a"/>
      <!-- Lashes -->
      <line x1="41" y1="35" x2="40" y2="33" stroke="#1a1a1a" stroke-width="1"/>
      <line x1="43" y1="34" x2="43" y2="32" stroke="#1a1a1a" stroke-width="1"/>
      <line x1="55" y1="34" x2="55" y2="32" stroke="#1a1a1a" stroke-width="1"/>
      <line x1="57" y1="35" x2="58" y2="33" stroke="#1a1a1a" stroke-width="1"/>
      <!-- Smile -->
      <path d="M43,46 Q50,52 57,46" stroke="#1a1a1a" stroke-width="2" fill="none" stroke-linecap="round"/>
    </svg>`
  },
  {
    id: "scientist",
    label: "Scientist",
    svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="48" fill="#E8F5E9"/>
      <!-- Lab coat -->
      <path d="M28,58 L34,53 L50,57 L66,53 L72,58 L70,83 L30,83Z" fill="white" stroke="#ddd" stroke-width="1"/>
      <!-- Coat lapels -->
      <path d="M34,53 L44,65 L44,83" stroke="#ddd" stroke-width="1" fill="none"/>
      <path d="M66,53 L56,65 L56,83" stroke="#ddd" stroke-width="1" fill="none"/>
      <!-- Pocket + flask -->
      <rect x="55" y="65" width="10" height="12" rx="2" fill="#e0e0e0"/>
      <ellipse cx="60" cy="72" rx="4" ry="5" fill="#64B5F6" opacity="0.8"/>
      <!-- Bubbles in flask -->
      <circle cx="58" cy="73" r="1.5" fill="white" opacity="0.8"/>
      <circle cx="61" cy="70" r="1" fill="white" opacity="0.8"/>
      <!-- Head -->
      <circle cx="50" cy="37" r="18" fill="#FFCC80"/>
      <!-- Hair -->
      <path d="M33,28 Q36,17 50,17 Q64,17 67,28" fill="#795548"/>
      <!-- Glasses -->
      <rect x="32" y="33" width="14" height="10" rx="4" fill="none" stroke="#1a1a1a" stroke-width="2"/>
      <rect x="54" y="33" width="14" height="10" rx="4" fill="none" stroke="#1a1a1a" stroke-width="2"/>
      <line x1="46" y1="38" x2="54" y2="38" stroke="#1a1a1a" stroke-width="2"/>
      <line x1="32" y1="38" x2="28" y2="36" stroke="#1a1a1a" stroke-width="2"/>
      <line x1="68" y1="38" x2="72" y2="36" stroke="#1a1a1a" stroke-width="2"/>
      <!-- Eyes behind glasses -->
      <circle cx="39" cy="38" r="2" fill="#1a1a1a"/>
      <circle cx="61" cy="38" r="2" fill="#1a1a1a"/>
      <!-- Smile -->
      <path d="M43,47 Q50,53 57,47" stroke="#1a1a1a" stroke-width="2" fill="none" stroke-linecap="round"/>
      <!-- Stars/sparks -->
      <text x="18" y="45" font-size="10">⚗️</text>
    </svg>`
  },
  {
    id: "ninja",
    label: "Ninja",
    svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="48" fill="#E8EAF6"/>
      <!-- Body -->
      <path d="M28,58 L35,53 L50,57 L65,53 L72,58 L70,83 L30,83Z" fill="#1a1a1a"/>
      <!-- Belt -->
      <rect x="30" y="66" width="40" height="6" rx="2" fill="#FF6A00"/>
      <rect x="47" y="64" width="6" height="10" rx="1" fill="#FF6A00"/>
      <!-- Head -->
      <circle cx="50" cy="37" r="19" fill="#1a1a1a"/>
      <!-- Face wrap gap - eyes only visible -->
      <rect x="33" y="33" width="34" height="11" rx="2" fill="#FFCC80"/>
      <!-- Eyes -->
      <circle cx="42" cy="38" r="3.5" fill="white"/>
      <circle cx="58" cy="38" r="3.5" fill="white"/>
      <circle cx="43" cy="38" r="2" fill="#1a1a1a"/>
      <circle cx="59" cy="38" r="2" fill="#1a1a1a"/>
      <!-- Eye shine -->
      <circle cx="44" cy="37" r="0.8" fill="white"/>
      <circle cx="60" cy="37" r="0.8" fill="white"/>
      <!-- Star weapon -->
      <text x="68" y="30" font-size="16">✦</text>
    </svg>`
  },
  {
    id: "artist",
    label: "Artist",
    svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="48" fill="#FFF9C4"/>
      <!-- Smock -->
      <path d="M28,58 L35,53 L50,57 L65,53 L72,58 L70,83 L30,83Z" fill="#FF6A00" opacity="0.9"/>
      <!-- Paint splatters on smock -->
      <circle cx="40" cy="68" r="4" fill="#E91E63" opacity="0.7"/>
      <circle cx="55" cy="72" r="3" fill="#2196F3" opacity="0.7"/>
      <circle cx="45" cy="76" r="2" fill="#4CAF50" opacity="0.7"/>
      <!-- Palette -->
      <ellipse cx="72" cy="70" rx="12" ry="9" fill="#F5F5F5" stroke="#ddd" stroke-width="1"/>
      <circle cx="67" cy="68" r="3" fill="#E91E63"/>
      <circle cx="73" cy="65" r="3" fill="#FF6A00"/>
      <circle cx="78" cy="69" r="3" fill="#2196F3"/>
      <circle cx="73" cy="74" r="3" fill="#4CAF50"/>
      <!-- Paintbrush -->
      <rect x="60" y="58" width="3" height="16" rx="1" fill="#8D6E63" transform="rotate(-30 62 66)"/>
      <path d="M56,54 L62,58 L60,62 L54,58Z" fill="#FF6A00" transform="rotate(-30 58 58)"/>
      <!-- Head -->
      <circle cx="50" cy="37" r="18" fill="#FFCC80"/>
      <!-- Beret -->
      <ellipse cx="50" cy="23" rx="16" ry="8" fill="#9C27B0"/>
      <ellipse cx="50" cy="21" rx="13" ry="5" fill="#7B1FA2"/>
      <circle cx="58" cy="20" r="3" fill="#9C27B0"/>
      <!-- Eyes -->
      <circle cx="43" cy="38" r="3" fill="white"/>
      <circle cx="57" cy="38" r="3" fill="white"/>
      <circle cx="44" cy="38" r="1.5" fill="#1a1a1a"/>
      <circle cx="58" cy="38" r="1.5" fill="#1a1a1a"/>
      <!-- Smile -->
      <path d="M43,46 Q50,52 57,46" stroke="#1a1a1a" stroke-width="2" fill="none" stroke-linecap="round"/>
    </svg>`
  },
  {
    id: "gamer",
    label: "Gamer",
    svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="48" fill="#EDE7F6"/>
      <!-- Hoodie -->
      <path d="M28,58 L35,50 L50,56 L65,50 L72,58 L70,83 L30,83Z" fill="#512DA8"/>
      <!-- Hoodie pocket -->
      <rect x="38" y="68" width="24" height="14" rx="4" fill="#4527A0"/>
      <!-- Controller in pocket -->
      <rect x="41" y="71" width="18" height="9" rx="3" fill="#7E57C2"/>
      <circle cx="55" cy="73" r="1.5" fill="#FF6A00"/>
      <circle cx="58" cy="76" r="1.5" fill="#4CAF50"/>
      <circle cx="46" cy="75" r="3" fill="#512DA8"/>
      <!-- Head -->
      <circle cx="50" cy="37" r="18" fill="#FFCC80"/>
      <!-- Gaming headset -->
      <path d="M32,35 Q32,18 50,18 Q68,18 68,35" stroke="#1a1a1a" stroke-width="4" fill="none"/>
      <rect x="28" y="33" width="8" height="12" rx="4" fill="#512DA8"/>
      <rect x="64" y="33" width="8" height="12" rx="4" fill="#512DA8"/>
      <!-- Mic -->
      <line x1="28" y1="44" x2="24" y2="50" stroke="#1a1a1a" stroke-width="2"/>
      <circle cx="23" cy="51" r="2" fill="#FF6A00"/>
      <!-- Eyes -->
      <circle cx="43" cy="37" r="3" fill="white"/>
      <circle cx="57" cy="37" r="3" fill="white"/>
      <circle cx="44" cy="37" r="1.5" fill="#512DA8"/>
      <circle cx="58" cy="37" r="1.5" fill="#512DA8"/>
      <!-- Grin -->
      <path d="M42,46 Q50,53 58,46" stroke="#1a1a1a" stroke-width="2" fill="none" stroke-linecap="round"/>
    </svg>`
  },
  {
    id: "chef",
    label: "Chef",
    svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="48" fill="#FBE9E7"/>
      <!-- Chef whites -->
      <path d="M28,58 L36,53 L50,57 L64,53 L72,58 L70,83 L30,83Z" fill="white" stroke="#ddd" stroke-width="1"/>
      <!-- Buttons -->
      <circle cx="50" cy="62" r="2" fill="#FF6A00"/>
      <circle cx="50" cy="69" r="2" fill="#FF6A00"/>
      <circle cx="50" cy="76" r="2" fill="#FF6A00"/>
      <!-- Spoon -->
      <ellipse cx="72" cy="65" rx="5" ry="7" fill="#e0e0e0" stroke="#bbb" stroke-width="1"/>
      <rect x="70" y="72" width="4" height="14" rx="2" fill="#e0e0e0" stroke="#bbb" stroke-width="1"/>
      <!-- Head -->
      <circle cx="50" cy="40" r="18" fill="#FFCC80"/>
      <!-- Chef hat -->
      <rect x="35" y="18" width="30" height="6" rx="3" fill="white" stroke="#ddd" stroke-width="1"/>
      <ellipse cx="50" cy="18" rx="18" ry="10" fill="white" stroke="#ddd" stroke-width="1"/>
      <ellipse cx="50" cy="14" rx="12" ry="8" fill="white"/>
      <!-- Eyes -->
      <circle cx="43" cy="40" r="3" fill="white"/>
      <circle cx="57" cy="40" r="3" fill="white"/>
      <circle cx="44" cy="40" r="1.5" fill="#1a1a1a"/>
      <circle cx="58" cy="40" r="1.5" fill="#1a1a1a"/>
      <!-- Rosy cheeks -->
      <circle cx="38" cy="45" r="4" fill="#FF8A80" opacity="0.4"/>
      <circle cx="62" cy="45" r="4" fill="#FF8A80" opacity="0.4"/>
      <!-- Big smile -->
      <path d="M41,48 Q50,56 59,48" stroke="#1a1a1a" stroke-width="2" fill="none" stroke-linecap="round"/>
    </svg>`
  },
  {
    id: "explorer",
    label: "Explorer",
    svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="48" fill="#E8F5E9"/>
      <!-- Jacket -->
      <path d="M28,58 L36,52 L50,56 L64,52 L72,58 L70,83 L30,83Z" fill="#795548"/>
      <!-- Pockets -->
      <rect x="33" y="65" width="12" height="10" rx="2" fill="#6D4C41"/>
      <rect x="55" y="65" width="12" height="10" rx="2" fill="#6D4C41"/>
      <!-- Map -->
      <rect x="38" y="54" width="24" height="16" rx="2" fill="#FFF9C4" transform="rotate(-10 50 62)"/>
      <line x1="40" y1="60" x2="58" y2="58" stroke="#FF6A00" stroke-width="1" transform="rotate(-10 50 62)"/>
      <line x1="40" y1="64" x2="55" y2="62" stroke="#FF6A00" stroke-width="1" transform="rotate(-10 50 62)"/>
      <!-- Head -->
      <circle cx="50" cy="37" r="18" fill="#FFCC80"/>
      <!-- Explorer hat -->
      <ellipse cx="50" cy="22" rx="20" ry="5" fill="#795548"/>
      <rect x="35" y="17" width="30" height="8" rx="3" fill="#8D6E63"/>
      <!-- Hat band -->
      <rect x="35" y="22" width="30" height="3" fill="#FF6A00"/>
      <!-- Eyes -->
      <circle cx="43" cy="37" r="3" fill="white"/>
      <circle cx="57" cy="37" r="3" fill="white"/>
      <circle cx="44" cy="37" r="1.5" fill="#1a1a1a"/>
      <circle cx="58" cy="37" r="1.5" fill="#1a1a1a"/>
      <!-- Rosy cheeks -->
      <circle cx="38" cy="43" r="4" fill="#FF8A80" opacity="0.4"/>
      <circle cx="62" cy="43" r="4" fill="#FF8A80" opacity="0.4"/>
      <!-- Smile -->
      <path d="M43,46 Q50,52 57,46" stroke="#1a1a1a" stroke-width="2" fill="none" stroke-linecap="round"/>
    </svg>`
  },
  {
    id: "dinosaur",
    label: "Dino",
    svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="48" fill="#E8F5E9"/>
      <!-- Dino costume body -->
      <path d="M28,58 L36,52 L50,56 L64,52 L72,58 L70,83 L30,83Z" fill="#66BB6A"/>
      <!-- Dino spikes on costume -->
      <polygon points="36,52 40,42 44,52" fill="#4CAF50"/>
      <polygon points="44,52 48,40 52,52" fill="#4CAF50"/>
      <polygon points="52,52 56,42 60,52" fill="#4CAF50"/>
      <!-- Belly -->
      <ellipse cx="50" cy="68" rx="12" ry="10" fill="#A5D6A7"/>
      <!-- Head -->
      <circle cx="50" cy="37" r="18" fill="#FFCC80"/>
      <!-- Dino hood/hat -->
      <path d="M33,28 Q36,16 50,14 Q64,16 67,28 Q62,20 50,21 Q38,20 33,28Z" fill="#66BB6A"/>
      <!-- Hood spikes -->
      <polygon points="38,20 41,10 44,20" fill="#4CAF50"/>
      <polygon points="47,17 50,7 53,17" fill="#4CAF50"/>
      <polygon points="56,20 59,10 62,20" fill="#4CAF50"/>
      <!-- Eyes -->
      <circle cx="43" cy="37" r="3.5" fill="white"/>
      <circle cx="57" cy="37" r="3.5" fill="white"/>
      <circle cx="44" cy="37" r="2" fill="#1a1a1a"/>
      <circle cx="58" cy="37" r="2" fill="#1a1a1a"/>
      <!-- Eye shine -->
      <circle cx="45" cy="36" r="0.8" fill="white"/>
      <circle cx="59" cy="36" r="0.8" fill="white"/>
      <!-- Big grin -->
      <path d="M40,47 Q50,55 60,47" stroke="#1a1a1a" stroke-width="2.5" fill="none" stroke-linecap="round"/>
      <!-- Teeth -->
      <line x1="45" y1="47" x2="45" y2="51" stroke="#1a1a1a" stroke-width="1.5"/>
      <line x1="50" y1="48" x2="50" y2="52" stroke="#1a1a1a" stroke-width="1.5"/>
      <line x1="55" y1="47" x2="55" y2="51" stroke="#1a1a1a" stroke-width="1.5"/>
    </svg>`
  }
  ,{
    id: "cr7",
    label: "CR7 🐐",
    testerOnly: true,
    svg: `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <radialGradient id="cr7bg" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stop-color="#e8f5e9"/>
          <stop offset="100%" stop-color="#c8e6c9"/>
        </radialGradient>
      </defs>
      <!-- Background -->
      <circle cx="50" cy="50" r="48" fill="url(#cr7bg)"/>
      <!-- Gold ring - GOAT status -->
      <circle cx="50" cy="50" r="47" fill="none" stroke="#FFD700" stroke-width="2" stroke-dasharray="5 2.5" opacity="0.9"/>

      <!-- Arms out - celebration pose -->
      <!-- Left arm -->
      <path d="M30,60 Q18,55 12,50" stroke="#FFCC80" stroke-width="7" fill="none" stroke-linecap="round"/>
      <circle cx="12" cy="50" r="5" fill="#FFCC80"/>
      <!-- Right arm -->
      <path d="M70,60 Q82,55 88,50" stroke="#FFCC80" stroke-width="7" fill="none" stroke-linecap="round"/>
      <circle cx="88" cy="50" r="5" fill="#FFCC80"/>

      <!-- Body - white Real Madrid/Portugal style kit -->
      <path d="M30,60 L36,54 L50,58 L64,54 L70,60 L68,83 L32,83Z" fill="white" stroke="#e0e0e0" stroke-width="1"/>
      <!-- Kit collar -->
      <path d="M44,54 Q50,60 56,54" fill="none" stroke="#e0e0e0" stroke-width="2"/>
      <!-- Number 7 -->
      <text x="50" y="76" text-anchor="middle" fill="#1a1a1a" font-size="16" font-weight="900" font-family="Arial Black, Arial">7</text>
      <!-- Gold captain band on left arm -->
      <path d="M22,51 Q20,48 22,45" stroke="#FFD700" stroke-width="4" fill="none" stroke-linecap="round"/>

      <!-- Head -->
      <circle cx="50" cy="37" r="19" fill="#D4A574"/>
      <!-- CR7 signature undercut hair -->
      <path d="M32,30 Q34,16 50,15 Q66,16 68,30 Q63,21 50,22 Q37,21 32,30Z" fill="#1a1a1a"/>
      <!-- Fade sides -->
      <path d="M32,30 Q30,35 31,40" stroke="#8B6914" stroke-width="3" fill="none"/>
      <path d="M68,30 Q70,35 69,40" stroke="#8B6914" stroke-width="3" fill="none"/>
      <!-- Hair texture line -->
      <path d="M35,22 Q50,18 65,22" stroke="#333" stroke-width="1" fill="none" opacity="0.4"/>

      <!-- Strong jaw / chin -->
      <path d="M34,46 Q50,58 66,46" stroke="#C49060" stroke-width="1" fill="none"/>

      <!-- Eyes - intense focus -->
      <circle cx="43" cy="36" r="3.5" fill="white"/>
      <circle cx="57" cy="36" r="3.5" fill="white"/>
      <circle cx="44" cy="36" r="2.2" fill="#3E2723"/>
      <circle cx="58" cy="36" r="2.2" fill="#3E2723"/>
      <circle cx="44.8" cy="35.2" r="0.8" fill="white"/>
      <circle cx="58.8" cy="35.2" r="0.8" fill="white"/>
      <!-- Eyebrows - furrowed intensity -->
      <path d="M40,32 Q43,30 46,31" stroke="#1a1a1a" stroke-width="2" fill="none" stroke-linecap="round"/>
      <path d="M54,31 Q57,30 60,32" stroke="#1a1a1a" stroke-width="2" fill="none" stroke-linecap="round"/>

      <!-- Confident smirk -->
      <path d="M44,46 Q51,52 58,47" stroke="#1a1a1a" stroke-width="2" fill="none" stroke-linecap="round"/>

      <!-- SIUUU text -->
      <text x="50" y="94" text-anchor="middle" fill="#1a1a1a" font-size="7" font-weight="900" font-family="Arial" opacity="0.7">SIUUU 🐐</text>

      <!-- Stars -->
      <text x="6" y="22" font-size="10">⭐</text>
      <text x="78" y="20" font-size="10">⭐</text>
    </svg>`
  }
];

export default avatars;
